import { createColumnHelper } from "@tanstack/react-table"
import dayjs from "dayjs"
import { useEffect, useState } from "react"
import { Spinner } from "react-bootstrap"
import DataTable from "../../components/dataTable/DataTable"
import { ApiEndpoints, reqPostNew } from "../../config/apiClient"

interface iProps {
    id_qrcode: number
}

export default function QrCodeUltimosRegistros({ id_qrcode }:iProps) {
    const [loading, setLoading] = useState<boolean>(true)
    const [dados, setDados] = useState<any[]>([])

    useEffect(() => {
        carregarDados()
        // eslint-disable-next-line
    }, [])

    async function carregarDados() {
        const filtro = {
            id_qrcode: id_qrcode,
        }

        setLoading(true)
        const api = await reqPostNew(ApiEndpoints.qrcodeRegistrosId, filtro)
        
        if (api.status === 200) {
            setDados(api.data)
            console.table(api.data)
        }
        
        setLoading(false)
    }

    return (
        <div>
            {loading && <Spinner />}
            {!loading && <DataTable dados={dados} tableSize={'auto'} defaultColumns={defaultColumns} tableMiddleClickhandler={() => {}} tableClickhandler={() => {}} defaultOrder={defaultOrder} defaultRows={23} />}
        </div>
    )
}

const columnHelper = createColumnHelper<any>()

const defaultColumns = [
    columnHelper.accessor(row => `${dayjs(row.data_criacao).format("DD/MM/YYYY HH:mm:ss")} #${row.id_scan}`, {
        header: 'Registro em',
        size: 300,
    }),
    columnHelper.accessor(row => `#${row.matricula} | ${row.nome_completo}`, {
        header: 'Colaborador',
        size: 500,
    }),
    columnHelper.accessor(row => `#${row.id_qrcode} | ${row.descricao}`, {
        header: 'QRCode',
        size: 500,
    }),
    columnHelper.accessor(row => `${row.internet} ${row.conexao}`, {
        header: 'Conexão',
        size: 300,
    }),
    columnHelper.accessor(row => `${row.latitude}, ${row.longitude}`, {
        header: 'Lat/Long',
        size: 300,
    }),
    columnHelper.accessor(row => row.obs, {
        header: 'Observação',
        size: 300,
    }),
]

const defaultOrder:any[] = []
